import { getLastLocation } from '../components/routing/LastLocationProvider'

export function showLiveViewModal() {
	 window.location.hash='now-playing'
	 if(window.analytics){
		 window.analytics.page('Now Playing')
	}
}

export function hideLiveViewModal() {
	const previousLocation=getLastLocation()
	if(previousLocation){
		window.history.back(1)
	}else{
		window.location.hash=''
	}

}



// WEBPACK FOOTER //
// ./src/utils/liveViewModal.js